import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';


import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {setComponentState,setSidebarState} from '../../actions/Builder.js';
import SidebarSettingAccordion from './SidebarSettingAccordion.js';
import CodeMirror from 'react-codemirror';
import '../../../../node_modules/codemirror/mode/htmlmixed/htmlmixed.js';
import SidebarElementSetting from './SidebarElementSetting.js';

import SidebarElementSpacing from './SidebarElementSpacing.js';
import SidebarElementWrapper from './SidebarElementWrapper.js';

import SidebarElementHeader from './SidebarElementHeader.js';
import Select from "react-select";

import GeneralHelper from '../../modules/General.js';
import {Link} from "react-router";
import axios from "axios";
import RecommendationHelper from "../../containers/recommendations/RecommendationHelper";

class CrallRecommendation extends React.Component {
    constructor(props) {
        super(props);

        this.el = this.el.bind(this);
        this.handleBackClick = this.handleBackClick.bind(this);
        this.onChange = this.onChange.bind(this);
    }


    el() {
        return this.props.builder.components[this.props.id];
    }

    renderSettings() {
        return <div><SidebarElementSpacing text='Settings' />Dette er en test</div>;
    }

    handleBackClick() {
        this.props.setSidebarState({'visible':false});
    }

    onChange(v) {
        this.props.setComponentState(this.el().id,{value:v+'px'});
    }

    changeRecommendation = (value) => {
        this.props.setComponentState(this.el().id,{recommendation_id:value.id});
    }

    getRecommendations = () => {
        return axios.get('/recommendations?type=email').then(res => {
            this.props.setComponentState(this.el().id,{recommendations:res.data});

            res.data = res.data.map(p => {
                return p;
            })


            return {options:res.data};
        });
    }

    getRecommendationCode = () => {
        let code = '<span></span>';
        let recommendations = this.el().recommendations;

        for(let i in recommendations) {
            if(recommendations[i].id == this.el().recommendation_id) {
                code = RecommendationHelper.emailCode(recommendations[i],'crall');
            }
        }

        if(this.el().html != code) {
            this.props.setComponentState(this.el().id,{html:code});
        }

        return code;

    }

    render() {
        if(this.props.sidebar == true) {
            return(
                <div className="sidebar text" style={this.props.style}>
                    <SidebarElementHeader handleBackClick={this.handleBackClick} text="Recommendation" />
                    <div className="alert dark alert-icon alert-info" role="alert">
                        <i className="icon wb-alert" aria-hidden="true"></i>
                        To create or edit recommendations you need to visit the recommendation page in the admin area.<br /><br />
                        <Link className={"btn btn-dark"} to={GeneralHelper.Link("/recommendations")}>Open recommendations</Link>
                    </div>

                    <SidebarElementSetting text="Select recommendation">
                        <Select.Async
                            autoload={true}
                            valueKey="id"
                            labelKey="description"
                            simpleValue={false}
                            multi={false}
                            name="form-field-name"
                            value={this.el().recommendation_id}
                            loadOptions={this.getRecommendations}
                            onChange={this.changeRecommendation}
                        />
                    </SidebarElementSetting>



                </div>
            );
        }else{
            if(this.el().recommendation_id == '' || !this.el().recommendation_id || this.el().recommendation_id == '0') {
                return (
                    <div className="alert dark alert-icon alert-info" role="alert">
                        <i className="icon wb-alert"aria-hidden="true"></i>

                        <strong>Note:</strong> Please select a recommendation from the sidebar
                    </div>

                )
            }else{

                return <div dangerouslySetInnerHTML={{__html: this.getRecommendationCode()}} />;
            }
        }

    }
}
const mapStateToProps = (state) => {
    return {
        builder:state.builder,
        general:state.general

    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({setComponentState,setSidebarState},dispatch)
}

CrallRecommendation = connect(mapStateToProps,mapDispatchToProps)(CrallRecommendation);

export default CrallRecommendation;





// WEBPACK FOOTER //
// ./components/builder/Crallrecommendation.js